import { IUpdateStatusObraChecklistServicoUseCase } from "../../../presentation/useCases/update/update_status_obra_checklist_servico_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateObraChecklistServicoUseCase
 */

export class UpdateStatusObraChecklistServicoUseCase implements IUpdateStatusObraChecklistServicoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateStatusObraChecklistServico(
    idObraChecklistServico: number,
    status: number,
  ): Promise<void> {
    await this.repository.updateStatusObraChecklistServico(
      idObraChecklistServico, status);
  }
}
